import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import MainCards from "../../components/MainCards";
import HomeBannerCard from "../../components/HomeBannerCard";
import img1 from "../../assets/images/real estate _1.jpg";
import img2 from "../../assets/images/real estate _10.jpg";
import img3 from "../../assets/images/real estate _11.jpg";
import logo from "../../assets/favicon/znet.jpg";
import CityRealEstateList from "../../components/CityRealEstateList";
import RealEstateTabs from "../../components/RealEstateTabs";
import RentByCityList from "../../components/RentByCityList";
import Footer from "../../components/Footer";
import Header from "../../components/header";
import TaglineHeader from "../../components/TaglineHeader";
import Testimonial from "../../components/Testimonial";
import PurposeSection from "../../components/PurposeSection";
import ProcessSection from "../../components/ProcessSection";
import WhyZnet from "../../components/WhyZnet";
import AppartementsRealEstate from "../../components/AppartementsRealEstate";
import GetLocation from "../../components/ProductByLocation";
import UserProfiling from "../../components/UserProfiling";
import { toast, ToastContainer } from "react-toastify";
import Recommendations from "../../components/Recommandation";
import { Helmet } from "react-helmet";
import { Modal, Button, ListGroup } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import UpcomingEvents from "../../components/UpcomingEvents";
import ExecutiveLeaders from "../../components/ExecutiveLeaders";
import SuccessStories from "../../components/SuccessStories";
import CharacterCard from "../../components/CharacterCard";
import CEO from "../../assets/images/ceo.jpg";
import COO from "../../assets/images/DJ jr Eschbach.jpg";
import Nalley from "../../assets/images/Jash Nalley.jpg";
import Sir from "../../assets/images/sir.jpg";
import { Carousel } from 'react-bootstrap';
import '../Home/Home.css';
import ProfileSetupWrapper from "../../components/ProfileSetupModal/ProfileSetupWrapper";

const Home = () => {
    const propertyImages = [img1, img2, img3];
    const [showModal, setShowModal] = useState(false);
    const [userRole, setUserRole] = useState("Guest");
    const [userId, setUserId] = useState(null);
    const [similarUsers, setSimilarUsers] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    const [leaders, setLeaders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [imagePath, setImagePath] = useState('');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Handle window resize for responsive design
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // ✅ Handle token and user data from URL redirect (OAuth)
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tokenFromUrl = params.get("token");
        const userIdFromUrl = params.get("user_id");
        const userEmailFromUrl = params.get("email");

        if (tokenFromUrl) {
            // Save token and other details to localStorage
            const decodedToken = decodeURIComponent(tokenFromUrl);
            const bearerToken = `Bearer ${decodedToken}`;
            localStorage.setItem("token", bearerToken);
            localStorage.setItem("user_id", userIdFromUrl);
            localStorage.setItem("user_email", userEmailFromUrl);

            // Fetch user details after saving the token
            fetchUserDetails(bearerToken);

            // Clean URL (remove token and other params from the address bar)
            window.history.replaceState({}, document.title, "/");
        }

        const errorFromUrl = params.get("error");
        if (errorFromUrl) {
            toast.error(decodeURIComponent(errorFromUrl));
            window.history.replaceState({}, document.title, "/");
        }
    }, [location.search]);

    // Fetch user role and userId from localStorage
    const fetchUserRole = () => {
        const storedUserRole = localStorage.getItem("roles");
        setUserRole(storedUserRole || "Guest");
    };

    const fetchUserId = () => {
        const storedUserId = localStorage.getItem("user_id");
        setUserId(storedUserId || null);
    };

    useEffect(() => {
        fetchUserRole();
        fetchUserId();
        fetchLeaders();

        const handleStorageChange = (event) => {
            if (event.key === "roles") {
                fetchUserRole();
            }
        };

        window.addEventListener("storage", handleStorageChange);
        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    const fetchSimilarUsers = useCallback(async () => {
        if (!userId) return;
        try {
            const res = await axios.get(
                `https://api.biznetusa.com/api/getsimilarusers/${userId}`
            );
            setSimilarUsers(res.data.similar_users || []);
            setShowModal(true);
        } catch (err) {
            console.error("Failed to fetch similar users:", err);
            setSimilarUsers([]);
        }
    }, [userId]);

    useEffect(() => {
        fetchSimilarUsers();
    }, [userId]);

    const handleUserSelect = (user) => {
        navigate(`/Start-chat-with-znet`, {
            state: {
                user_id: userId,
                receiver_id: user.user_id,
                name: user.name,
            },
        });
    };

    // Fetch executive leaders
    const fetchLeaders = async () => {
        try {
            const response = await axios.get("https://api.biznetusa.com/api/all-executiveleaders");
            setLeaders(response.data.leaders);
            setImagePath(response.data.imagePath);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching leaders:", error);
            setLoading(false);
        }
    };

    // Determine cards per slide based on screen width
    const getCardsPerSlide = () => {
        if (windowWidth < 576) {
            return 1; // Mobile: 1 card per slide
        } else if (windowWidth < 992) {
            return 2; // Tablet: 2 cards per slide
        } else {
            return 4; // Desktop: 4 cards per slide
        }
    };

    const chunk = (array, size) => {
        if (!array) return [];

        const chunked_arr = [];
        for (let i = 0; i < array.length; i += size) {
            chunked_arr.push(array.slice(i, i + size));
        }
        return chunked_arr;
    };

    // Get the number of cards per slide based on screen width
    const cardsPerSlide = getCardsPerSlide();

    // Create groups of leaders based on the current cards per slide
    const leaderGroups = chunk(leaders, cardsPerSlide);

    // Fetch user profile data
    const fetchUserDetails = async () => {
        // Get token from localStorage
        const token = localStorage.getItem("token");
        if (!token) {
            toast.error("User not authenticated.");
            return;
        }

        try {
            // Make the API call to fetch the logged-in user's details
            const response = await fetch("https://api.biznetusa.com/api/user/me", {
                method: "GET",
                headers: {
                    "Authorization": token,  // Send the Bearer token to authenticate
                    "Content-Type": "application/json",
                },
            });

            if (!response.ok) {
                throw new Error("Failed to fetch user details.");
            }

            const userData = await response.json();
            const { id, email, user_role, permissions } = userData.user;

            // Store user details in localStorage
            localStorage.setItem("user_id", id);
            localStorage.setItem("user_email", email);
            localStorage.setItem("roles", user_role);
            localStorage.setItem("permissions", JSON.stringify(permissions));

            // Redirect to homepage or another page after fetching profile
            navigate("/");

        } catch (error) {
            toast.error(error.message || "Failed to fetch user details.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <ProfileSetupWrapper>
            <Helmet>
                <title>BizNet Real Estate Home</title>
                <meta
                    name="description"
                    content="Explore top properties in prime locations with BizNet Real Estate. Find your dream home or apartment in Chevy Chase and surrounding areas today."
                />
                <meta
                    name="keywords"
                    content="real estate, Znet, homes for sale, apartments for rent, Chevy Chase, luxury properties, real estate listings"
                />
                <meta property="og:title" content="Znet Real Estate Home" />
                <meta
                    property="og:description"
                    content="Discover and explore top properties available in Chevy Chase and other prime locations with Znet Real Estate. Begin your journey home with us."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />
                <meta property="og:image" content={logo} />
                <meta property="twitter:image" content={logo} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Znet Real Estate Home" />
                <meta
                    name="twitter:description"
                    content="Find your dream property in prime locations like Chevy Chase with Znet Real Estate. Check out our premier listings and make an informed choice."
                />
                <meta name="twitter:image" content={logo} />
            </Helmet>
            <ToastContainer />
            <TaglineHeader />
            <Header />
            <main className="Main_portion">
                {userId ? (
                    <div className="container-fluid px-4 pb-4 g-0 rounded bg-light">
                        <div id="anas__pava" className="d-flex">
                            <RealEstateTabs />
                            <HomeBannerCard
                                images={propertyImages}
                                location="Chevy Chase, MD"
                                price="$3,599,000"
                                title="BizNet PREMIER LISTING"
                            />
                        </div>
                    </div>
                ) : (
                    <HomeBannerCard isLarge={true} />
                )}

                {/* Similar Users Modal */}
                <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                    <Modal.Header style={{ backgroundColor: "var(--background_color)" }} closeButton>
                        <Modal.Title>Similar Users</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="bg-white">
                        {similarUsers.length > 0 ? (
                            <ListGroup>
                                {similarUsers.map((user) => (
                                    <ListGroup.Item
                                        key={user.user_id}
                                        className="d-flex justify-content-between align-items-center"
                                    >
                                        <span>{user.name}</span>
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() => handleUserSelect(user)}
                                        >
                                            Chat
                                        </Button>
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        ) : (
                            <p className="text-center text-muted">
                                No similar users found.
                            </p>
                        )}
                    </Modal.Body>
                </Modal>

                {userId ? (
                    <>
                        <MainCards />
                        <GetLocation />
                    </>
                ) : (
                    <Recommendations />
                )}
                {!userId && (
                    <>
                        <PurposeSection />
                        <ProcessSection />
                        <WhyZnet />
                        <Testimonial />
                        <SuccessStories />
                    </>
                )}
                <UpcomingEvents />

                {/* Updated Executive Leadership Section */}
                <div className="container my-5">
                    <h3 className="text-center mb-5 display-5 fw-bold">Executive Leadership</h3>

                    {loading ? (
                        <div className="text-center p-5">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2">Loading executives...</p>
                        </div>
                    ) : (
                        <Carousel defaultActiveIndex={0} interval={null} className="executive-leadership-carousel">
                            {leaderGroups.map((group, idx) => (
                                <Carousel.Item key={idx}>
                                    <div className={`d-flex flex-wrap justify-content-${cardsPerSlide === 1 ? 'center' : 'around'}`}>
                                        {group.map(leader => (
                                            <div
                                                className={`p-2 card-container ${cardsPerSlide === 1 ? 'w-100' : ''} ${cardsPerSlide === 2 ? 'w-50' : ''}`}
                                                key={leader.id}
                                                style={{ maxWidth: cardsPerSlide === 1 ? '100%' : cardsPerSlide === 2 ? '50%' : '25%' }}
                                            >
                                                <CharacterCard
                                                    name={leader.title}
                                                    title={leader.role}
                                                    description={leader.description}
                                                    image={leader.image ? `${imagePath}${leader.image}` : "placeholder-image-url.jpg"}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    )}
                </div>

            </main>

            <div className="container py-4">
                <h3 className="m-3">Search for homes by city</h3>
                <CityRealEstateList />
                <hr className="my-5" />
                <h3 className="m-3">Search for apartments by city</h3>
                <AppartementsRealEstate />
                <hr className="my-5" />
                <h3 className="m-3">Search for houses for rent by city</h3>
                <RentByCityList />
            </div>

            <Footer />
        </ProfileSetupWrapper>
    );
};

export default Home;
